/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Image, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const NavigationListItem = (props) => {
  const {
    title,
    href,
    depth,
    children,
    className,
    code,
    isLastItem,
    open: openProp,
    label: Label,
    pageid,
    ...rest
  } = props;

  const location = useLocation();

  const themeState = useSelector(state => state.themeState);

  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((open) => !open);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = {
    paddingLeft,
  };
  
  const imageSrc = code === 'dashboards' 
  ? themeState.themeMode === 'dark' 
    ? '/assets/images/icon-ai-dark.svg' 
    : '/assets/images/icon-ai.svg'
  : code === 'access-manage' 
    ? themeState.themeMode === 'dark' 
      ? '/assets/images/user-manage-dark.svg' 
      : '/assets/images/user-manage.svg'
    : themeState.themeMode === 'dark' 
      ? '/assets/images/default-icon-dark.svg' 
      : '/assets/images/default-icon.svg';
      
  // const imageSrc = code === 'ai-management' ? '/assets/images/icon-ai.svg': code === 'access-manage' ? '/assets/images/user-manage.svg': '/assets/images/default-icon.svg';
  const itemClass = isLastItem  ? '' : 'sidebar-menu-line';
 
  if (children) {
    return (
      <>
        <div className="">
          <p className="font-14 font-weight-medium d-flex align-items-center mb-2">
            <Image src={imageSrc} className="me-2" />
            {title}
          </p>
        </div>
        {children}
      </>
    );
  } else {
  

    const isActive = location.pathname === '/' + href;

    return (
      <div className={`side-bar-tabs side_bar_margin ${itemClass}`}>
       
       <p className="">
          <Link to={'/' + href}>
            {isActive ? (
            <Image src="/assets/images/active.svg" className="active-before"/>
               ) : (
           <Image src="/assets/images/inactive.svg" />)}
  
           <Button variant="none" className={`border-0 font-13 font-weight-normal text-secondary ${isActive ? "active-sidebar" : ""}`}>
            {title}
           </Button>

         </Link> 
       </p>
      </div>
    );
  }
};

NavigationListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavigationListItem.defaultProps = {
  depth: 0,
  open: false,
};

export default NavigationListItem;
